import type { SeasonDeepContent, SubseasonDeepContent } from "./types";
import { springDeepContent } from "./spring";
import { summerDeepContent } from "./summer";
import { autumnDeepContent } from "./autumn";
import { winterDeepContent } from "./winter";

export * from "./types";

export const deepContent: { [seasonKey: string]: SeasonDeepContent } = {
  SPRING: springDeepContent,
  SUMMER: summerDeepContent,
  AUTUMN: autumnDeepContent,
  WINTER: winterDeepContent,
};

export function getDeepContent(
  season: string,
  subSeason: string
): SubseasonDeepContent | undefined {
  return deepContent[season.toUpperCase()]?.[subSeason.toUpperCase()];
}
